import { ErrorHandler, Injectable, inject } from '@angular/core';

import { SentryService } from './sentry.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryService = inject(SentryService);

  handleError(error: Error) {
    this.sentryService.log(error);
  }
}
